import React from 'react'

import Link from 'components/Link'
import Meta from 'components/Meta'
import SignUpForm from 'components/SignUpForm'
import UnauthBox from 'components/UnauthBox'
import UnauthView from 'components/UnauthView'
import paths from 'constants/paths'

export default function SignUp() {
  const title = 'Create account'

  return (
    <UnauthView className="SignUp">
      <Meta title={title} />
      <UnauthBox
        title={title}
        actions={
          <Link to={paths.SIGN_IN} icon="plus-circle" muted>Sign in</Link>
        }>
        <p>
          AMAL is in private beta. Please enter your invite code and email to get started.
        </p>
        <SignUpForm />
      </UnauthBox>
    </UnauthView>
  )
}



// WEBPACK FOOTER //
// ./src/views/SignUp/SignUp.js